import { LOCALSTORAGE_IDS } from '../data/constants';
import { allStorageKeys } from './storage';

// Cookies allowed to survive a decline. Nothing in this codebase writes
// document.cookie, so every cookie present on the domain was set by a third
// party (gtag) and none of them are strictly necessary.
const ESSENTIAL_COOKIES = [];

// The consent record itself has to survive, otherwise declining would bring the
// banner straight back on the next load. 'popup' is the change-country
// preference: functional, no tracking.
const ESSENTIAL_STORAGE_KEYS = [
  LOCALSTORAGE_IDS.USER_COOKIES,
  LOCALSTORAGE_IDS.CHANGE_COUNTRY_POPUP,
];

const EXPIRED = 'Thu, 01 Jan 1970 00:00:00 GMT';

// A cookie can only be deleted by repeating the domain and path it was set
// with, and document.cookie exposes neither. gtag sets _ga on the registrable
// domain, so try the current host and every ancestor of it.
function domainVariants() {
  const { hostname } = window.location;
  const variants = [null, hostname, `.${hostname}`];
  const parts = hostname.split('.');
  for (let i = 1; i < parts.length - 1; i += 1) {
    variants.push(`.${parts.slice(i).join('.')}`);
  }
  return variants;
}

// Same problem for paths: '/' covers almost everything, but a cookie set on a
// narrower path can only be removed from that path.
function pathVariants() {
  const paths = ['/'];
  let current = '';
  window.location.pathname
    .split('/')
    .filter(Boolean)
    .forEach(segment => {
      current += `/${segment}`;
      paths.push(current);
    });
  return paths;
}

function expire(name, path, domain) {
  const attributes = [`${name}=`, `expires=${EXPIRED}`, `path=${path}`];
  if (domain) {
    attributes.push(`domain=${domain}`);
  }
  document.cookie = attributes.join('; ');
}

// Expires every cookie on this domain that is not explicitly essential.
// Limits worth knowing: this can only reach cookies on our own domain and only
// those without the HttpOnly flag. Google's own _GRECAPTCHA and NID live on
// google.com and cannot be touched from here.
export function clearNonEssentialCookies() {
  try {
    const names = [
      ...new Set(
        document.cookie
          .split(';')
          .map(pair => pair.split('=')[0].trim())
          .filter(Boolean)
      ),
    ].filter(name => !ESSENTIAL_COOKIES.includes(name));

    const domains = domainVariants();
    const paths = pathVariants();

    names.forEach(name =>
      paths.forEach(path =>
        domains.forEach(domain => expire(name, path, domain))
      )
    );
  } catch (error) {
    // Cookie access blocked: there is nothing we can clear.
  }
}

// localStorage and sessionStorage are "similar technologies" under ePrivacy, so
// a decline has to clear them too, not just cookies.
export function clearNonEssentialStorage() {
  allStorageKeys().forEach(([storage, keys]) => {
    keys
      .filter(key => !ESSENTIAL_STORAGE_KEYS.includes(key))
      .forEach(key => {
        try {
          storage.removeItem(key);
        } catch (error) {
          // Skip keys we are not allowed to remove.
        }
      });
  });
}
